import {
  FiUsers,
  FiBook,
  FiFileText,
  FiBell,
  FiGlobe,
  FiShoppingCart, // Added for E-commerce main menu
  FiTag,          // Added for Products
  FiLayers        // Added for Categories/Variants
} from "react-icons/fi";

const Menu = [
  {
    heading: "Main Navigation",
  },
  {
    name: "Users",
    path: "/users",
    icon: FiUsers,
    permissions: ["admin", "users"],
  },

  {
    name: "E-Commerce",
    icon: FiShoppingCart,
    permissions: ["admin", "users"],
    children: [
      {
        name: "Products",
        path: "/ecommerce/products",
        icon: FiTag,
      },
      {
        name: "Categories",
        path: "/ecommerce/categories",
        icon: FiLayers,
      },
      {
        name: "Variants",
        path: "/ecommerce/variants",
        icon: FiLayers,
      },
      {
        name: "Orders",
        path: "/ecommerce/orders",
        icon: FiLayers,
      }
    ]
  },

  {
    name: "Contact Us",
    path: "/contact",
    icon: FiUsers,
    permissions: ["admin", "users"],
  },
  {
    name: "Content Management",
    path: "/contentmanagement",
    icon: FiBook,
    permissions: ["admin", "users"],
  },
  {
    name: "Notification",
    path: "/notification",
    icon: FiBell,
    permissions: ["admin", "users"],
  },
  {
    name: "Pledge",
    path: "/pledge",
    icon: FiUsers,
    permissions: ["admin", "users"],
  },
  {
    name: "FAQ",
    path: "/faq",
    icon: FiFileText,
    permissions: ["admin", "users"],
  },
  {
    name: "Course",
    path: "/course",
    icon: FiBook,
    permissions: ["admin", "users"],
  },
  {
    name: "Campaign Management",
    path: "/campaignmanagement",
    icon: FiGlobe,
    permissions: ["admin", "users"],
  },
  {
    name: "ImageUploadPage",
    path: "/upload",
    icon: FiGlobe,
    permissions: ["admin", "users"],
  }
];

export default Menu;